import size from "../sizes";

export default [
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `
        <p>Платье с классическим рукавом, слегка открывающим запястья. Простой и лаконичный покрой открывает большой простор для нанесения любого принта. Круглый вырез и легкий клеш к низу делают это платье еще более универсальным.</p>
        <p>Материалы:<br>100% микрофибра<br>Интерлок, 285</p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `
        <p>Способ печати - сублимация. Принт становится частью ткани и не чувствуется на ощупь. Картинка получается яркой и сочной. Изображение не стирается, не выцветает и не трескается.</p>
        <p>Можно стирать в машинке. Гладить, желательно, на изнанку.</p>
      `
    }
  },
  {
    id: `size`,
    title: `Размерная сетка`,
    content: {
      table: size[`long_sleeve_dress`],
      sizeInfo: `long_sleeve_dress`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
